var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SUserLayout,{attrs:{"sidebarTitle":"settings.title","sidebarIcon":"mdi-cog","sidebarItems":_setup.items}},[_c('div',{staticClass:"setting-page-container__content d-flex justify-content-center"},[_c('RouterView')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }